import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Submission } from '../../../team-apis/otterdam/submission';
import { Task } from '../../../team-apis/otterdam/task';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';
import { SamplingWorkspaceStore } from '../../sampling-workspace/state/sampling-workspace-store';

@Component({
  selector: 'h3-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarComponent {
  @Input() stepId?: number;
  @Input() submissions?: Submission[];
  projectType$: Observable<string>;
  isProjectPaused$: Observable<boolean>;
  task$: Observable<Task>;
  isInternalUser$: Observable<boolean>;

  constructor(
    store: TaskWorkspaceStore,
    samplingStore: SamplingWorkspaceStore,
  ) {
    this.task$ = store('task').$;
    this.projectType$ = store('project')('project_type').$;
    this.isProjectPaused$ = store('project')('state').$.pipe(
      map((state) => state === 'paused'),
    );
    this.isInternalUser$ = samplingStore('master').$.pipe(
      startWith(undefined),
      map((master) => master?.context !== 'external_qa'),
    );
  }

  // we want to stop click propagation because we don't want to close the
  // expansion panel when clicking on copy task url button or selecting the task
  // id for example
  preventExpansionPanelFromClosing(event: MouseEvent) {
    event.stopPropagation();
  }
}
